import { ReactElement } from "react";

export function ApiErrorContent(): ReactElement {
  return <div className="error-text"> Error Fetching Details </div>;
}
